import { X } from "lucide-react";
import { useState, useEffect, useRef } from "react";

/** Toggle this to show/hide the maintenance banner across the app */
const IS_MAINTENANCE_ACTIVE = false;

export function MaintenanceBanner() {
  const [dismissed, setDismissed] = useState(false);
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!IS_MAINTENANCE_ACTIVE || dismissed) {
      document.documentElement.style.setProperty("--banner-height", "0px");
    } else {
      const updateHeight = () => {
        const h = bannerRef.current?.offsetHeight ?? 0;
        document.documentElement.style.setProperty("--banner-height", `${h}px`);
      };
      updateHeight();
      window.addEventListener("resize", updateHeight);
      return () => window.removeEventListener("resize", updateHeight);
    }
  }, [dismissed]);

  if (!IS_MAINTENANCE_ACTIVE || dismissed) return null;

  return (
    <div
      ref={bannerRef}
      className="fixed top-0 left-0 right-0 z-40 w-full bg-amber-50 border-b border-amber-200 text-amber-800 text-xs sm:text-sm font-medium"
    >
      <div className="flex items-center justify-center px-10 py-1.5 relative">
        <span>🔧 Mamy chwilowe zawirowania techniczne — pracujemy nad tym!</span>
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-amber-600 hover:text-amber-900 transition-colors p-1"
          aria-label="Zamknij"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
